import { render, staticRenderFns } from "./ParcelLink.vue?vue&type=template&id=41b5572e&"
import script from "./ParcelLink.vue?vue&type=script&lang=js&"
export * from "./ParcelLink.vue?vue&type=script&lang=js&"
import style0 from "./ParcelLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports